import RequistionCartReducer from "@tKgpco/Handlers/RequistionCart/RequistionCartReducer";
import AccessorialsReducer from "@tKgpco/Store/Data/Accessorials/AccessorialsReducer";
import EditAccessorialReducer from "@tKgpco/Store/Data/Accessorials/EditAccessorialReducer";
import orderConfirmationEmailReducer from "@tKgpco/Store/Data/AccountSettings/AccountSettingsOrderConfirmationEmailReducer";
import ApplyDateToAllLineReducer from "@tKgpco/Store/Data/Cart/ApplyDateToAllLineReducer";
import CartReelQtyReducer from "@tKgpco/Store/Data/Cart/CartReelQtyReducer";
import CheckoutReviewReducer from "@tKgpco/Store/Data/CheckoutReviewAndSubmit/CheckoutReviewReducer";
import CheckoutShippingDeliveryAddressReducer from "@tKgpco/Store/Data/CheckoutShipping/CheckoutShippingDeliveryAddressReducer";
import USPSValidateReducer from "@tKgpco/Store/Data/CheckoutShipping/CheckoutShippingUSAddressValidateReducer";
import DiscrepancyReducer from "@tKgpco/Store/Data/DiscrepancyHistory/DiscrepancyReducer";
import CustomInvoiceHistory from "@tKgpco/Store/Data/InvoiceHistoy/InvoiceHistoryReducerExtension";
import ItemTrackingReducer from "@tKgpco/Store/Data/ItemTracking/ItemTrackingReducer";
import CustomInvoiceHistoryOrderList from "@tKgpco/Store/Data/OrderHistory/InvoiceHistoryOrderListReducer";
import OrderHistoryAttributeReducer from "@tKgpco/Store/Data/OrderHistory/OrderHistoryAttributeReducer";
import CustomOrderHistory from "@tKgpco/Store/Data/OrderHistory/OrderHistoryReducerExtension";
import LoadOrderLineDetailsReducer from "@tKgpco/Store/Data/OrderHistoryDetail/LoadOrderLineDetailsReducer";
import LoadOrderMessagesReducer from "@tKgpco/Store/Data/OrderHistoryDetail/LoadOrderMessagesReducer";
import CustomPackagingSlips from "@tKgpco/Store/Data/PackagingSlips/PackagingSlipsReducer";
import ProductMultipleQtyReducer from "@tKgpco/Store/Data/ProductMultipleQty/ProductMultipleQtyReducer";
import ReportHistoryReducer from "@tKgpco/Store/Data/ReportHistory/ReportHistoryReducer";
import RfqSecondarySalesPersonReducer from "@tKgpco/Store/Data/RfqSecondarySalesPerson/RfqSecondarySalesPersonReducer";
import RMAReducer from "@tKgpco/Store/Data/RMA/RMAReducer";
import RolesReducer from "@tKgpco/Store/Data/SecurityRoles/RolesReducer";
import EditTermReducer from "@tKgpco/Store/Data/Terms/EditTermReducer";
import TermsReducer from "@tKgpco/Store/Data/Terms/TermsReducer";
import UploadComingSoonProductReducer from "@tKgpco/Store/Data/UploadComingSoonProduct/UploadComingSoonProductReducer";
import VendorsReducer from "@tKgpco/Store/Data/Vendors/VendorsReducer";
import WORCarriersReducer from "@tKgpco/Store/Data/WOR/WORCarriersReducer";
import { combineReducers } from "redux";

const customReducers = {
    USPS: USPSValidateReducer,
    orderConfirmationEmail: orderConfirmationEmailReducer,
    CheckoutReview: CheckoutReviewReducer,
    customOrderHistory: CustomOrderHistory,
    customInvoiceHistory: CustomInvoiceHistory,
    customPackagingSlips: CustomPackagingSlips,
    vendorsState: VendorsReducer,
    worCarriers: WORCarriersReducer,
    customAccessorials: AccessorialsReducer,
    customEditAccessorial: EditAccessorialReducer,
    customTerms: TermsReducer,
    customEditTerm: EditTermReducer,
    customInvoiceHistoryOrderList: CustomInvoiceHistoryOrderList,
    SecondarySalesTermAdded: RfqSecondarySalesPersonReducer,
    UploadComingSoonProduct: UploadComingSoonProductReducer,
    ReportHistoryStore: ReportHistoryReducer,
    ShippingDeliveryInfoStore: CheckoutShippingDeliveryAddressReducer,
    ProductMultipleQtyStore: ProductMultipleQtyReducer,
    CartReelQtyStore: CartReelQtyReducer,
    ApplyDateToAllLineStore: ApplyDateToAllLineReducer,
    OrderHistoryAttributeStore: OrderHistoryAttributeReducer,
    OrderLinesDetailStore: LoadOrderLineDetailsReducer,
    LoadOrderMessagesStore: LoadOrderMessagesReducer,
    DiscrepancyStore: DiscrepancyReducer,
    RMAStore: RMAReducer,
    ItemTrackingStore: ItemTrackingReducer,
    SecurityRolesStore: RolesReducer,
    RequistionCartStore: RequistionCartReducer,
};

export type CustomDataReducers = typeof customReducers;

const customDataReducer = combineReducers(customReducers as any);

export default customDataReducer;
